import httpHubless from 'hub-http/clients/noPortalApiClient';
import Endpoints from '../constants/apiEndpoints';
import ErrorTypes from '../constants/ErrorTypes';
import TwoFactorAuthMethod from '../constants/twoFactorAuthMethod';
import TwoFactorRequestStatus from '../constants/TwoFactorRequestStatus';
import PrecedenceLevels from '../constants/precedenceLevels';
let token = '';
const checkMobileAuthPressed = () => new Promise((resolve, reject) => {
  if (token.length < 1) {
    reject(new Error(ErrorTypes.NO_TOKEN));
  }
  httpHubless.get(`${Endpoints.MOBILE_AUTHENTICATOR_POLL}/${token}`).then(result => {
    if (result === TwoFactorRequestStatus.INVALID) {
      reject(new Error(result));
    } else {
      resolve(result);
    }
  }).catch(err => {
    reject(err);
  });
});
const tryAuthentication = args => {
  return new Promise((resolve, reject) => {
    if (token.length < 1) {
      reject(new Error(ErrorTypes.NO_TOKEN));
    }
    const twoFactorLevel = args.authMethod === TwoFactorAuthMethod.BACKUP_CODE ? 'BACKUP' : args.twoFactorLevel;
    const data = {
      twoFactorLevel,
      token,
      code: args.code
    };
    const authEndpoint = args.authMethod === TwoFactorAuthMethod.HUBSPOT_AUTHENTICATOR && args.mobilePush ? Endpoints.MOBILE_AUTHENTICATOR_POLL_APPROVE : Endpoints.TWO_FACTOR_AUTHENTICATE;
    httpHubless.post(authEndpoint, {
      data
    }).catch(reject).then(result => {
      if (result === 'OK') {
        resolve();
      } else {
        reject(new Error(result));
      }
    }).catch(reject);
  });
};
const setToken = newToken => {
  token = newToken;
};
const resendTwoFactor = isPrimaryMethod => {
  return new Promise((resolve, reject) => {
    const data = {
      token,
      twoFactorLevel: isPrimaryMethod ? PrecedenceLevels.PRIMARY : PrecedenceLevels.SECONDARY
    };
    httpHubless.post(`${Endpoints.TWO_FACTOR_SMS_RESEND}`, {
      data
    }).then(() => {
      resolve({
        key: 'sms'
      });
    }).catch(err => {
      const responseJSON = err && err.responseText && JSON.parse(err.responseText);
      if (responseJSON && responseJSON.status === 'NEEDS_EMAIL_FALLBACK') {
        if (responseJSON && responseJSON.errorTokens && responseJSON.errorTokens.token[0]) {
          setToken(responseJSON.errorTokens.token[0]);
          resolve({
            key: 'email',
            emailInfo: responseJSON.errorTokens.email
          });
        }
      } else {
        reject(err);
      }
    });
  });
};
const callForCode = isPrimaryMethod => {
  return new Promise((resolve, reject) => {
    const data = {
      token,
      twoFactorLevel: isPrimaryMethod ? PrecedenceLevels.PRIMARY : PrecedenceLevels.SECONDARY
    };
    httpHubless.post(`${Endpoints.TWO_FACTOR_SMS_CALL}`, {
      data
    }).then(() => {
      resolve({
        key: 'call'
      });
    }).catch(err => {
      reject(err);
    });
  });
};
export { tryAuthentication, checkMobileAuthPressed, setToken, resendTwoFactor, callForCode };